import * as React from "react";
import SetPassword from "../../presentations/SetPassword";

const SetPasswordContainer = () => {
  return (
    <div>
      <SetPassword></SetPassword>
    </div>
  );
};

export default SetPasswordContainer;
